import {create} from 'zustand';
import {EventSummaryDto} from '../../generated/models/EventSummaryDto';
import {EventDetailDto} from '../../generated/models/EventDetailDto';

export type EventSummaryInternalDto = EventSummaryDto;

export interface EventListStore {
  eventList: EventSummaryInternalDto[] | null;
  selectedEventId: string | null;
  setEventList: (eventList: EventSummaryInternalDto[]) => void;
  setSelectedEventId: (eventId: string) => void;
  clearEventListStore: () => void;
}

export interface EventDetailsStore {
  eventDetails: EventDetailDto | null;
  selectedEventDetailsId: string | null;
  setEventDetails: (eventDetails: EventDetailDto) => void;
  setSelectedEventDetailsId: (eventDetailsId: string) => void;
  clearEventDetails: () => void;
}

export interface EventDtoStore {
  eventDto: EventDetailDto | null;
  setEventDto: (eventDetails: EventDetailDto) => void;
  clearEventDto: () => void;
}

export const useEventListStore = create<EventListStore>()(set => ({
  eventList: null,
  selectedEventId: null,
  setEventList(eventList) {
    set({eventList});
  },
  setSelectedEventId(eventId) {
    set({selectedEventId: eventId});
  },
  clearEventListStore() {
    set({eventList: null, selectedEventId: null});
  },
}));

export const useEventDetailsStore = create<EventDetailsStore>()(set => ({
  eventDetails: null,
  selectedEventDetailsId: null,
  setSelectedEventDetailsId(selectedEventDetailsId) {
    set({selectedEventDetailsId});
  },
  setEventDetails(eventDetails) {
    set({eventDetails});
  },
  clearEventDetails() {
    set({eventDetails: null, selectedEventDetailsId: null});
  },
}));

export const useEventDtoStore = create<EventDtoStore>()(set => ({
  eventDto: null,
  setEventDto(eventDto) {
    set({eventDto});
  },
  clearEventDto() {
    set({eventDto: null});
  },
}));
